export default defineNuxtPlugin(async () => {
  if (!import.meta.client) return;

  // if (!/appfactory/i.test(navigator.userAgent)) return;

  const authCookie = useCookie("auth");
  if (authCookie.value) return;

  const token = localStorage.getItem("token");
  if (!token) return;

  try {
    const config = useRuntimeConfig();
    const fullUrl = `${config.public.apiServer}/api/user/readUserInfo`;

    // useApi 안 쓰고 raw fetch — 공통 에러핸들러 완전 우회
    const res = await fetch(fullUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      credentials: "include",
      body: JSON.stringify({ token }),
    });

    if (!res.ok) {
      console.warn("autoLogin: HTTP 오류", res.status);
      return; // 조용히 종료
    }

    const response = await res.json();

    if (!response || response.resCd !== "0000") {
      console.warn("autoLogin: 토큰 검증 실패", response?.resCd);
      return; // 조용히 종료
    }

    // 검증 성공 → auth 상태 복원
    const authState = useAuthState();
    authState.setAuth(
      token,
      { userKey: response.result.userKey },
      response.result.joinType ?? null
    );

    localStorage.setItem("userKey", response.result.userKey);
    console.log("APP 자동로그인 완료");

  } catch (e) {
    // 네트워크 오류 등 — 조용히 무시
    console.warn("autoLogin: 실패 (무시)", e.message);
  }
});